import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWall2Left: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowWall2Left"><Path d="M9.25 7.25L4.5 12L9.25 16.75" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 12H5.25" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 4.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowWall2Left;
